var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFulfillFavourite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fulfill_favourite",
    transform: "translate(-2313 -74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fulfill_favourite-2",
    "data-name": "fulfill_favourite",
    d: "M0,0H24V24H0Z",
    transform: "translate(2313 74)",
    fill: "rgba(255,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fulfill_favourite-3",
    "data-name": "fulfill_favourite",
    d: "M12,55.35a.7.7,0,0,1-.352-.094A41.986,41.986,0,0,1,5.877,51.1a23.805,23.805,0,0,1-4-4.289A9.048,9.048,0,0,1,0,41.667,7.431,7.431,0,0,1,1.9,36.69a6.212,6.212,0,0,1,4.626-2.1A6.418,6.418,0,0,1,12,37.843a6.418,6.418,0,0,1,5.479-3.249,6.249,6.249,0,0,1,4.446,1.892A7.325,7.325,0,0,1,24,41.675a9.223,9.223,0,0,1-1.91,5.139,24.113,24.113,0,0,1-4,4.287,42.135,42.135,0,0,1-5.74,4.151.7.7,0,0,1-.354.1Z",
    transform: "translate(2313 41.406)",
    fill: "#dc3a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFulfillFavourite);
export default __webpack_public_path__ + "static/media/fulfill_favourite.903faf3b648612dc08946ce7242fb10e.svg";
export { ForwardRef as ReactComponent };